import { forwardRef } from 'react';

import { Button } from '@crehana/compass.ui/button';

interface TSeeAllCardProps {
  titleCard?: string;
  titleButton: string;
  onActionShowMore?: () => void;
}

export const SeeAllCard = forwardRef<HTMLDivElement, TSeeAllCardProps>(
  ({ titleCard, titleButton, onActionShowMore }, ref) => {
    return (
      <div
        ref={ref}
        className="tw-w-full tw-h-full tw-rounded-2 tw-flex tw-justify-end tw-flex-col tw-bg-primary-light-600 dark:tw-bg-primary-dark-700 tw-p-2"
      >
        {titleCard && (
          <p className="tw-font-subtitle1 md:tw-font-subtitle3 tw-text-neutral-light-100 tw-mb-1.2">
            {titleCard}
          </p>
        )}
        <Button
          type="button"
          variant="white"
          size="xs"
          className="tw-self-start"
          onClick={onActionShowMore}
        >
          {titleButton}
        </Button>
      </div>
    );
  },
);

SeeAllCard.displayName = 'SeeAllCard';
